

function Cache(name, cacheExpiration) {
    this.name = name;
    this.cacheExpiration = cacheExpiration || this.cacheExpiration;
    this._caches = {};
    this._cacheExpirationTimeouts = {};
}

Cache.prototype.cacheExpiration = 1000;

Cache.prototype._getCacheForKey = function (cacheKey) {
    if (!this._caches[cacheKey]) {
        this._caches[cacheKey] = {};
    }
    if (this._cacheExpirationTimeouts[cacheKey]) {
        clearTimeout(this._cacheExpirationTimeouts[cacheKey]);
    }
    this._cacheExpirationTimeouts[cacheKey] = setTimeout(() => {
        this._caches[cacheKey] = void 0;
    }, this.cacheExpiration);
    return this._caches[cacheKey];
};

Cache.prototype.get = function (cacheKey, key, loaderFn) {
    const cache = this._getCacheForKey(cacheKey);
    if (cache.hasOwnProperty(key)) {
        return cache[key];
    }
    cache[key] = loaderFn();
    return cache[key];
};

module.exports = Cache;

